export const ZERO_UUID = '00000000-0000-4000-8000-000000000000';
export const VIAFOURA_ROOT_UUID = '56696166-6f75-7261-0000-000000000000';
